module.exports = __webpack_public_path__ + "img/1519600549.cc29c245.jpg";